
























































































































































import Vue from "vue";
import Component from "vue-class-component";
import {Watch} from "vue-property-decorator";
import {useRentalStore} from "@/store/rental";
import type {RentalDevice} from "@/api/models/rental";
import SmbButton from "@/components/ui/SmbButton/SmbButton.vue";
import SmbTextArea from "@/components/ui/SmbTextArea/SmbTextArea.vue";
import SmbApiAlert from "@/components/ui/SmbAlert/SmbApiAlert.vue";

@Component({
  components: {
    SmbButton,
    SmbTextArea,
    SmbApiAlert,
  },
  metaInfo() {
    const device = (this as RentalDeviceDetails).device;
    return {
      title: device ? device.name : "Leihgerät",
    };
  },
})
export default class RentalDeviceDetails extends Vue {
  public isLoading = true;
  public isSubmitting = false;
  public selectedImageId: number | null = null;
  public errorMessage = "";
  public successMessage = "";
  public message = "";

  public get deviceId(): number {
    return parseInt(this.$route.params.id, 10);
  }

  public get device(): RentalDevice | null {
    return useRentalStore().currentDevice;
  }

  public get deviceImages(): { id: number; fileName: string; contentType: string }[] {
    return this.device && this.device.images ? this.device.images : [];
  }

  public get selectedMedia(): { id: number; contentType: string } {
    const id = this.selectedImageId || (this.deviceImages.length > 0 ? this.deviceImages[0].id : 0);
    const image = this.deviceImages.find(img => img.id === id);
    return image || { id: 0, contentType: "" };
  }

  public isVideo(contentType: string): boolean {
    return contentType === "video/mp4";
  }

  public async mounted(): Promise<void> {
    await this.loadDevice();
  }

  @Watch("$route.params.id")
  public async onIdChanged(): Promise<void> {
    await this.loadDevice();
  }

  public async loadDevice(): Promise<void> {
    this.isLoading = true;
    this.selectedImageId = null;
    this.successMessage = "";
    this.errorMessage = "";
    this.message = "";

    try {
      const rentalStore = useRentalStore();
      const device = await rentalStore.fetchRentalDeviceById(this.deviceId, true);
      if (device && device.images && device.images.length > 0) {
        this.selectedImageId = device.images[0].id;
      }
    } catch (e) {
      console.error("Error loading device:", e);
    } finally {
      this.isLoading = false;
    }
  }

  public getImageUrl(imageId: number): string {
    const rentalStore = useRentalStore();
    return rentalStore.getImageUrl(imageId);
  }

  public formatPrice(price: number): string {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(price);
  }

  public async submitInquiry(): Promise<void> {
    this.errorMessage = "";
    this.successMessage = "";
    this.isSubmitting = true;

    try {
      const rentalStore = useRentalStore();
      // Send request with placeholder dates - admin will handle actual scheduling
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const startDate = today.toISOString().split("T")[0];
      const endDate = tomorrow.toISOString().split("T")[0];
      const result = await rentalStore.createRentalRequest(
        this.deviceId,
        startDate,
        endDate,
        this.message || null
      );

      if (result.success) {
        this.successMessage = "Ihre Anfrage wurde erfolgreich gesendet! Wir werden uns in Kürze bei Ihnen melden.";
        this.message = "";
      } else {
        this.errorMessage = result.message || "Fehler beim Senden der Anfrage.";
      }
    } catch (e) {
      console.error("Error submitting inquiry:", e);
      this.errorMessage = "Fehler beim Senden der Anfrage.";
    } finally {
      this.isSubmitting = false;
    }
  }
}
